import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetAccountComponent';

var styles = AppSettings.styles;

class VipSystema extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="mg-vip-system" className="mg-user-widget">
                <div id="mg-saldo-importo">
                    <span className="mg-user-widget-titolo">VIP System</span>
                    <span className="mg-saldo-punti"><i className="fa fa-star" aria-hidden="true"></i> Livello <strong>ORO</strong>, <strong>1980</strong> punti accumulati</span>
                </div>
            </div>

        );
    }
}

VipSystema.displayName = componentName;

// PropTypes validation
VipSystema.propTypes = {
};

// default props
VipSystema.defaultProps = {
};

export default VipSystema;